import { useQuery } from ".."

export const useSurveys = () => {
  const { data, error, loading } = useQuery({
    url: "/surveys/all",
    requestData: { publicOnly: true },
  })
  return { surveys: data, surveysError: error, surveysLoading: loading }
}
